import { Row, Col } from 'react-bootstrap';
import React, { useEffect, useRef } from 'react';

import Table, { RowsType } from '../Shared/CustomTable';
import Loader from '../Shared/Loader';
import PacketGraph from '../Shared/Graphics/PacketGraph';
import { fixDecimals } from '../../helpers/helpers';

import './HealthTab.scss';
import { useHealthDispatch, useHealthState } from '../../store/hooks/health';
import { FILTER_KEYS } from '../../config/constants';
import { useFiltersState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import { SensorData } from './types';

export default () => {
  const second = useRef(false);
  const { summaryData, sensorsData, packetGraphData } = useHealthState();
  const { specificScope } = useRouter();
  const { [FILTER_KEYS.VENUE]: venue,
          [FILTER_KEYS.TIME_SLIDER]: timeSlider
        } = useFiltersState(specificScope, FILTER_KEYS.VENUE, FILTER_KEYS.TIME_SLIDER);
  const { getSummaryHealthData: getMonitorData,
          getSensorsHealthData: getSensorsData,
          getPacketGraph,
          changeMessageNoData: noData
        } = useHealthDispatch();
  useEffect(() => {
    if (venue && venue.value && venue.value.siteId) {
      getMonitorData(venue.value.siteId, true);
      getSensorsData(venue.value.siteId, true);
      getPacketGraph(venue.value.siteId, true);
      second.current = true;
    } else {
      noData();
    }
  }, [venue]);
  useEffect(() => {
    if (second.current) {
      if (venue && venue.value.siteId && timeSlider) {
        getMonitorData(venue.value.siteId, !timeSlider.interval);
        getSensorsData(venue.value.siteId, !timeSlider.interval);
        getPacketGraph(venue.value.siteId, !timeSlider.interval);
      } else {
        noData();
      }
    }
  }, [timeSlider]);
  const headers = [
    { content: 'Packets', style: { width: '136px' } },
    { content: 'Total', style: { width: '165px' } },
    { content: '%', style: { width: '303px' } }
  ];
  const rows = [];
  if (Object.keys(summaryData).length > 0) {
    rows.push({
      columns: [{ content: 'T' }, { content: summaryData.tcount }, { content: fixDecimals(summaryData.tpercent, 2) }],
      id: 'T'
    });
    rows.push({
      columns: [{ content: 'D' }, { content: summaryData.dcount }, { content: fixDecimals(summaryData.dpercent, 2) }],
      id: 'D'
    });
    rows.push({
      columns: [{ content: 'P' }, { content: summaryData.pcount }, { content: fixDecimals(summaryData.ppercent, 2) }],
      id: 'P'
    });
    rows.push({
      columns: [{ content: 'N' }, { content: summaryData.ncount }, { content: fixDecimals(summaryData.npercent, 2) }],
      id: 'N'
    });
    rows.push({
      columns: [{ content: 'Total' }, { content: summaryData.totalcount }, { content: '' }],
      id: 'Total'
    });
  }
  const headersSensors = [
    { content: 'Sensor', style: { width: '83px' } },
    { content: 'Location', style: { width: '166px' } },
    { content: 'Age(sec)', style: { width: '148px' } },
    { content: 'T(total)', style: { width: '106px' } },
    { content: 'N(total)', style: { width: '101px' } }
  ];
  const rowsSensors:RowsType<string, number> = [];
  sensorsData.forEach((data:SensorData) => {
    rowsSensors.push({
      columns: [{ content: data.id }, { content: data.location }, { content: data.last_time }, { content: data.t_total }, { content: data.n_total }],
      id: ""+data.id
    });
  });
  return (<Row>
      <Col lg={6} xs={12}>
        <div className="card-00" style={{ overflow: 'auto' }}>
          <div className="health-tt">Packet Graph</div>
          <div className="packet-l">
            <div className="packet-d"><i className="mdi mdi-ray-vertex" /> N Packets vs T</div>
            <div className="packet-d-01"><i className="mdi mdi-ray-vertex" /> T Packet</div>
          </div>
          <div style={{ height: 'calc(100% - 34px)' }}>
            <Loader forceScope={'HEALTH_PACKET_GRAPH'}>
              <PacketGraph width={600} height={250} data={packetGraphData} />
            </Loader>
          </div>
        </div>
        <div className="card-00" style={{ overflow: 'auto' }}>
          <div className="health-tt">Summary</div>
          <div style={{ height: 'calc(100% - 27px)' }}>
            <Loader forceScope={'HEALTH_SUMMARY'}>
              <div style={{ height: 'calc(100% - 26px)' }}>
                {rows.length > 0 && <Table classTable={'summary-table'} headers={headers} rows={rows} />}
              </div>
            </Loader>
          </div>
        </div>
      </Col>
      <Col lg={6} xs={12}>
        <div className="card-01" style={{ overflow: 'auto' }}>
          <div className="health-tt" style={{ textAlign: 'right' }}>{sensorsData.length} Result(s)</div>
          <div style={{ height: 'calc(100% - 27px)' }}>
            <Loader forceScope={'HEALTH_SENSORS'}>
              <div style={{ height: 'calc(100% - 26px)' }}>
                {rowsSensors.length > 0 && <Table headers={headersSensors} rows={rowsSensors} />}
              </div>
            </Loader>
          </div>
        </div>
      </Col>
    </Row>
  );
};
